import { globalConstants , refundPolicyConstants} from "../../constants";

const initialState = {
  RefundPolicyData: [],
};

const {
    GET_REFUND_POLICY_DATA,
    UDPATE_REFUND_POLICY_TYPE
} = refundPolicyConstants;

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REFUND_POLICY_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        RefundPolicyData: action.data,
      };
    case UDPATE_REFUND_POLICY_TYPE + globalConstants.SUCCESS:
      return {
        ...state,
        RefundPolicyData: action.data,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
